import React, { Fragment } from 'react';
import { object } from 'prop-types';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    StaticRouter,
} from 'react-router-dom';

const renderRoutes = (routes, extraProps = {}, switchProps = {}) => (routes ? (
    <Switch {...switchProps}>
        { routes.map((route, i) => (
            <Route
                key={i}
                path={route.path}
                exact={route.exact}
                strict={route.strict}
                render={props => (
                    <route.component {...props} {...extraProps} route={route} />
                )}
            />
        )) }
    </Switch>
) : null);

const SubRoutes = ({ route }) => (
    <Fragment>
        { renderRoutes(route.routes) }
    </Fragment>
);

SubRoutes.propTypes = {
    route: object.isRequired,
};

export default SubRoutes;
